import ky from 'ky';
import Config from './config';
import type { IndexesData } from './database/lib/IndexUtil';
import type { SimPFLink } from './database/lib/ItemUtil';

/**
 * Data converted from the original XOOPS modules. It is served with the rest of
 * static-contents/ rather than bundled, so it is fetched once at start up and
 * handed to the singletons before the app renders.
 */
export interface SiteData {
    tree: IndexesData;
    simpfLinks: SimPFLink[];
}

// ky hands the URL to fetch()/Request, which rejects bare relative paths.
const resolve = (path: string): string => new URL(Config.BASE_URL + path, window.location.href).toString();

export const loadSiteData = async (): Promise<SiteData> => {
    const [tree, simpfLinks] = await Promise.all([
        ky.get(resolve('/modules/xoonips/tree.json')).json<IndexesData>(),
        ky.get(resolve('/modules/xoonips/simpf-links.json')).json<SimPFLink[]>(),
    ]);
    return { tree, simpfLinks };
};
